import { ref, onMounted, onBeforeUnmount, useTemplateRef } from "vue";

const isOpen = ref(false);

export const closeDropdown = () => {
  isOpen.value = false;
};

export function useDropdown() {
  const modalRef = useTemplateRef<HTMLElement>("modalRef");

  const toggleDropdown = () => {
    isOpen.value = !isOpen.value;
  };

  const closeOnClickOutside = (event: Event) => {
    const target = event.target as HTMLElement;
    if (
      !target.closest("#themeDropdown") &&
      !modalRef.value?.contains(target)
    ) {
      closeDropdown();
    }
  };

  onMounted(() => {
    window.addEventListener("pointerdown", closeOnClickOutside, {
      capture: true,
    });
  });

  onBeforeUnmount(() => {
    window.removeEventListener("pointerdown", closeOnClickOutside, {
      capture: true,
    });
  });

  return { isOpen, modalRef, toggleDropdown, closeDropdown };
}
